import { render, staticRenderFns } from "./LinhaLogotipo.vue?vue&type=template&id=1ee9ecf6"
import script from "./LinhaLogotipo.vue?vue&type=script&lang=js"
export * from "./LinhaLogotipo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports